import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const banners = [
    {
        image: './banner0.png',
        title: 'Seu próximo carro está aqui',
        subtitle: 'Veículos selecionados com as melhores condições',
        align: 'left'
    },
    {
        image: './banner1.png',
        title: 'Qualidade e confiança',
        subtitle: 'Compra e venda com procedência garantida',
        align: 'center'
    },
    {
        image: './banner2.png',
        title: 'Financiamento facilitado',
        subtitle: 'Aprovamos seu crédito rapidamente',
        align: 'right'
    }
];


export default function BannerCarousel() {
    return (
        <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            loop
            className="w-full mt-24 md:mt-14"
        >
            {banners.map((banner, index) => (
                <SwiperSlide key={index} className="relative">
                    <img
                        src={banner.image}
                        alt={banner.title}
                        className="w-full h-[70vh] object-cover"
                    />

                    <div className="absolute inset-0 bg-black/50" />

                    <div className="absolute inset-0 flex items-center">
                        <div className="container mx-auto px-6 w-full">
                            <div
                                className={`
                    max-w-xl banner-content
                    ${banner.align === 'left' && 'text-left'}
                    ${banner.align === 'center' && 'text-center mx-auto'}
                    ${banner.align === 'right' && 'text-right ml-auto'}
                `}
                            >
                                <h2 className="text-white text-4xl md:text-5xl font-bold mb-4">
                                    {banner.title}
                                </h2>
                                <p className="text-gray-200 text-lg mb-6">
                                    {banner.subtitle}
                                </p>

                                <button
                                    className={`
                        bg-yellow-600 hover:bg-yellow-700 transition
                        px-6 py-3 rounded text-white font-semibold
                        ${banner.align === 'center' && 'mx-auto'}
                        ${banner.align === 'right' && 'ml-auto'}
                    `}
                                >
                                    Ver estoque
                                </button>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>

            ))}
        </Swiper>
    );
}
